import Button from './ui/Button';
import Icon from './ui/Icon';

export default function BackButton({ to }: { to: string }) {
  return (
    <Button size="xs" variant="secondary" className="self-start gap-1" to={to}>
      <Icon name="arrowBack" className="text-[18px]" /> Back
    </Button>
  );
}
